// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5ef7fc16","239":"2e27d2ca","453":"a272b4bb","455":"7f0f1f28"}[chunkId] + ".chunk.js";
};